import React from 'react'
import { connect } from 'react-redux'
import { Trans } from '@lingui/react'
import { getCurrentAnswerOptionChoice } from '../selectors.js'

const SelectedAnswerText = ({ optionChoice }) => (
  <div className="small faded">
    {optionChoice && (
      <Trans>
        You selected {optionChoice.value}
        {optionChoice.body && ` - ${optionChoice.body}`}
      </Trans>
    )}
  </div>
)

const mapStateToProps = state => ({
  optionChoice: getCurrentAnswerOptionChoice(state),
})

export default connect(mapStateToProps)(SelectedAnswerText)



// WEBPACK FOOTER //
// ./src/components/SelectedAnswerText.js